import dynamic from 'next/dynamic';
import { modalRegistry } from 'src/features/common/modal/providers/modal.registry';
import { ChooseBlockchainProps } from 'src/features/white-labels/techcontemporary/shared/modals/choose-blockchain-modal/choose-blockchain-modal.types';

const ChooseBlockchainComponent = dynamic(() => import('./choose-blockchain-modal'), {
    ssr: false,
});

export const ChooseBlockchainModal = modalRegistry.register<ChooseBlockchainProps>({
    id: 'ChooseBlockchain',
    component: ChooseBlockchainComponent,
});